import React from 'react';
import pingu from '../../../assets/svg/pingu.svg';
import insta from '../../../assets/svg/instagram.svg';
import face from '../../../assets/svg/facebook.svg';
import linked from '../../../assets/svg/linkedin.svg';
import { useScreenSize } from '../../../hooks/useScreenSize';

const About: React.FC = () => {
  const { isTablet } = useScreenSize();
  return (
    <section className="slide flex-colomn gap-2" id="item5">
      <div className={`${isTablet ? 'flex-colomn' : 'flex-row'} space-between w-100 gap-2`}>
        <div className={`flex-colomn justify-center`}>
          <h2>
            <span className="tertiary-color ">Wie </span>we zijn!
          </h2>
          <p className="slide-text-full">
            Onze mascotte <span className="bold">Pingu</span> – het koelste dier met het warmste
            hart – staat voor wie wij zijn: efficiënt, vriendelijk en altijd klaar om jouw leef- of
            werkruimte aangenaam te maken.{' '}
            <span className="bold">Slim, duurzaam en heerlijk comfortabel.</span> Dat is
            <span className="bold"> AirSolutions!</span>
          </p>
          <div className="flex-row-align gap-2 pt-1 ">
            <a href="https://www.instagram.com/airsolutionsbelgium/">
              <img src={insta} alt="" />
            </a>
            <a href="#!">
              <img src={linked} alt="" />
            </a>
            <a href="#!">
              <img src={face} alt="" />
            </a>
          </div>
        </div>
        <div className={`${isTablet ? 'flex-row justify-end' : 'flex-row-align'} gap-2`}>
          <img className="img" src={pingu} alt="pingu" />
        </div>
      </div>
    </section>
  );
};

export default About;
